import type { Direction } from '../game/state';
export class InputManager {
  private held=new Map<string,{direction:Direction;order:number;age:number}>();
  private serial=0;
  repeatFrames=10;
  initialDelay=18;
  constructor(private onDirection:(direction:Direction)=>void,private onClear:()=>void=()=>{}){}
  press(source:string,direction:Direction):void{
    if(this.held.get(source)?.direction===direction)return;
    this.held.set(source,{direction,order:++this.serial,age:0});this.onDirection(direction);
  }
  release(source:string):void{this.held.delete(source);}
  tap(direction:Direction):void{this.onDirection(direction);}
  clear():void{this.held.clear();this.onClear();}
  tick():void{
    let active:{direction:Direction;order:number;age:number}|undefined;
    for(const held of this.held.values())if(!active||held.order>active.order)active=held;
    if(!active)return;
    active.age++;
    if(active.age>=this.initialDelay&&(active.age-this.initialDelay)%this.repeatFrames===0)this.onDirection(active.direction);
  }
}
